import * as firebase from "firebase/app";

export const getWhereDocumentIdInIds = (ids, path, facilityId) => {
    // don't run if there aren't any ids or a path for the collection
    if (!ids || !ids.length || !path) return [];

    const _ids = [...ids]
    const collectionPath = firebase.firestore().collection(path);
    const batches = [];
    while (_ids.length) {
      // firestore limits batches to 10
      const batch = _ids.splice(0, 10);
      // add the batch request to to a queue

      if(facilityId){
        batches.push(collectionPath
          .where('facilityId', '==', facilityId)
          .where(firebase.firestore.FieldPath.documentId(), 'in', [...batch])
          .get()
          .then((results: any) => results.docs.map((result: any) => ({ id: result.id, ...result.data() }))))
      }else{
        batches.push(collectionPath
          .where(firebase.firestore.FieldPath.documentId(), 'in', [...batch])
          .get()
          .then((results: any) => results.docs.map((result: any) => ({ id: result.id, ...result.data() }))))
      }
      
    }
    // after all of the data is fetched, return it
    return Promise.all(batches)
      .then((content: any) => content.flat())
      .catch(error => {
        console.error(error);
        return [];
      });
}

export const getWhereIdInIds = (prop, ids, path, facilityId) => {
    // don't run if there aren't any ids or a path for the collection
    if (!ids || !ids.length || !path) return [];

    const _ids = [...ids]
    const collectionPath = firebase.firestore().collection(path);
    const batches = [];
    while (_ids.length) {
      // firestore limits batches to 10
      const batch = _ids.splice(0, 10);
      // add the batch request to to a queue

      if(facilityId){
        batches.push(collectionPath
          .where('facilityId', '==', facilityId)
          .where(prop, 'in', [...batch])
          .get()
          .then((results: any) => results.docs.map((result: any) => ({ id: result.id, ...result.data() }))))
      }else{
        batches.push(collectionPath
          .where(prop, 'in', [...batch])
          .get()
          .then((results: any) => results.docs.map((result: any) => ({ id: result.id, ...result.data() }))))
      }
      
    }
    // after all of the data is fetched, return it
    return Promise.all(batches).then((content: any) => content.flat());
}

export const getWhereIdInIdsExtended = (prop, ids, path, facilityId, additionalWhere = null) => {
  if (!ids || !ids.length || !path) return [];

  const _ids = [...ids]
  const collectionPath = firebase.firestore().collection(path);
  const batches = [];

  while (_ids.length) {
      const batch = _ids.splice(0, 10);
      let query: any = collectionPath;

      if (facilityId) {
          query = query.where('facilityId', '==', facilityId);
      }

      query = query.where(prop, 'in', batch);

      if (additionalWhere) {
          for (const condition of additionalWhere) {
              query = query.where(condition.field, condition.operator, condition.value);
          }
      }

      batches.push(query.get().then((results) => results.docs.map((result) => ({ id: result.id, ...result.data() }))));

  }

  return Promise.all(batches).then((content) => content.flat());
}